import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { LIBP_PREFETCHING_AGGRESSIVE_HOVER_THRESHOLD } from "@faire/web-api--source/indigofair/settings/LIBP_PREFETCHING_AGGRESSIVE_HOVER_THRESHOLD";


export const useSettingBrandPageAggressivePrefetchingThreshold = (): number => {
  return useSetting(LIBP_PREFETCHING_AGGRESSIVE_HOVER_THRESHOLD, 300);
};